module.exports = __webpack_public_path__ + "static/img/smuggler3.69db729.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/smuggler3.png
// module id = Hoql
// module chunks = 0